import { Badge, BadgeType } from '../../../../../../components/badge/badge';

interface EligibilityBadgesProps {
    eligibleCount: number;
    ineligibleCount: number;
    className?: string;
}

const EligibilityBadges: React.FC<EligibilityBadgesProps> = ({ 
    eligibleCount, 
    ineligibleCount, 
    className = "flex-center-small" 
}) => {
    return (
        <div className={className}>
            <Badge type={BadgeType.SUCCESS} text={`${eligibleCount} Eligible`} />
            {ineligibleCount > 0 && <Badge type={BadgeType.WARNING} text={`${ineligibleCount} Ineligible`} />}
        </div>
    );
};

export default EligibilityBadges;
